import React, { useState } from "react";
import { Box, Container } from "@material-ui/core";
import { Redirect } from "react-router-dom";
import { useIntl } from "react-intl";
import clsx from "clsx";

import { SignupLayout } from "../../common/SignupLayout";
import { useStyles } from "./SignupScreen.styles";
import { PersonaAccountForm } from "./components/PersonalAccountForm";
import { IdentificationInfoForm } from "./components/IdentificationInfoForm";
import {
  SignupContextProvider,
  stepOneFinished,
} from "../../context/SignupContext";
import { PageTitle } from "../../components/page-title/PageTitle";
import { SlideWrapper } from "../../components/slide-wrapper/SlideWrapper";
import { SignInScreen } from "../signin/SignInScreen";

export const SignupScreen = (props: any) => {
  const classes = useStyles(props);
  const intl = useIntl();
  // State
  const [step, setStep] = useState(1);

  const changeStep = (index: number) => {
    setStep(index);
  };

  if (!stepOneFinished()) {
    return <Redirect to={{ pathname: SignInScreen.routeName }} />;
  }

  return (
    <>
      <PageTitle title={intl.formatMessage({ id: "sharedScreen.signUp" })} />
      <SignupContextProvider>
        <SignupLayout mode="dark" withMenu={step === 2}>
          <Container maxWidth="sm">
            <Box className={classes.root}>
              <Container maxWidth="sm" className={classes.contentWrapper}>
                <Box
                  className={clsx({
                    [classes.hide]: step !== 1,
                  })}
                >
                  <SlideWrapper>
                    <PersonaAccountForm callback={() => changeStep(2)} />
                  </SlideWrapper>
                </Box>

                <Box
                  className={clsx({
                    [classes.hide]: step !== 2,
                  })}
                >
                  <SlideWrapper>
                    <IdentificationInfoForm
                      backCallback={() => changeStep(1)}
                    />
                  </SlideWrapper>
                </Box>
              </Container>
            </Box>
          </Container>
        </SignupLayout>
      </SignupContextProvider>
    </>
  );
};

SignupScreen.routeName = "/signup";
